import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-searchbar',
    templateUrl: './searchbar.component.html',
    styleUrls: ['./searchbar.component.scss'],
    standalone: false,
})
export class SearchbarComponent {
    searchValue = '';
    @Output() searchEvent = new EventEmitter<string>();

    onSearch(value: string) {
        this.searchValue = value;
        this.searchEvent.emit(value);
    }

    clearInput() {
        this.searchValue = '';
        this.onSearch('');
    }
}
